export const Wordmark = () => (
  <div className="hx-wordmark" data-testid="hausa-wordmark">
    <span className="hx-wordmark__name">hausA</span>
    <span className="hx-wordmark__tag">INTERIOR DESIGN STUDIO</span>
    <span className="hx-wordmark__by">by Flex Living</span>
  </div>
);

export const BrandBand = ({ children, wide = false }) => (
  <header className="hx-band" data-testid="brand-band">
    <div className={`hx-container ${wide ? "hx-container--wide" : ""} hx-band__inner`}>
      <Wordmark />
      {children}
    </div>
  </header>
);

export const SectionHeading = ({ children, testId }) => (
  <h2 className="hx-section__head" data-testid={testId}>{children}</h2>
);
